export default __webpack_public_path__ + "static/person-profile-dark-mode-596fbc9cb19ebfb5666169d5d057d12e.png";